import styled from 'styled-components';
import theme from '../../theme';

const StyledYblMinKyc = styled.div`
  .custom-input{
    &.ant-input{
      height: 30px;
      border-radius: 6px;
      background-color: ${theme.blenderGray};;
    }
  }
  .custom-datepicker {
    &.ant-calendar-picker{
      width: 100%;
    }
  }
  .outline-gray{
    border: 1px dashed ${theme.borderGray};
    border-radius: 4px;
    padding-bottom: 10px;
    background-color: ${theme.touchFeatherGray};
    .close-icon{
      height: 20px;
    }
  }
  .uploaded-img{
    width: 100%;
    height: 80px;
    object-fit: contain;
  }
  .line-ht-20{
    line-height: 20px;
  }
  .red-clr{
    color: ${theme.primaryColor};
  }
`;


export {
  StyledYblMinKyc,
};



// WEBPACK FOOTER //
// client/containers/YblMinKyc/StyledYblMinKyc.js